import React from 'react';

import {
  FormControl,
  FormControlProps,
  FormLabel,
  FormLabelProps,
  FormErrorMessage,
  Input,
  InputProps,
  rem,
} from '@vimeo/bokeh';

const activeLabelStyles = {
  transform: `scale(0.85) translateY(${rem(-22)})`,
  color: 'text-primary',
};

export const StyledInput = (props: InputProps) => (
  <Input placeholder="" _focusVisible={{ borderColor: 'text-primary' }} {...props} />
);

export const InputWrapper = (
  props: FormControlProps & { formFieldErrorMessage?: string | null },
) => (
  <FormControl
    position="relative"
    variant="floating"
    _focusWithin={{
      label: activeLabelStyles,
    }}
    sx={{
      'input:not(:placeholder-shown) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown) ~ label':
        activeLabelStyles,
      'input[aria-invalid="true"]:not(:placeholder-shown) + label': {
        color: 'status-destructive-primary',
      },
      zIndex: 2,
    }}
    {...props}
  >
    {props.children}
    <FormErrorMessage fontWeight={350} fontSize="body-sm" color="status-destructive-primary">
      {props?.formFieldErrorMessage}
    </FormErrorMessage>
  </FormControl>
);

export const Label = (props: FormLabelProps) => (
  <FormLabel
    position="absolute"
    top={0}
    left={0}
    zIndex={2}
    backgroundColor="white"
    pointerEvents="none"
    mx={3}
    px={1}
    my={rem(10)}
    transformOrigin="left top"
    fontSize={rem(14)}
    fontWeight={350}
    color="text-secondary"
    lineHeight="140%"
    letterSpacing="-3%"
    transition="0.2s ease all"
    {...props}
  >
    {props.children}
  </FormLabel>
);
